import { render, staticRenderFns } from "./RightBottomPopupNote.vue?vue&type=template&id=225d46d2&"
import script from "./RightBottomPopupNote.vue?vue&type=script&lang=js&"
export * from "./RightBottomPopupNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports